import PropTypes from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";

import unoPiggyBank from "Payments/FundItPage/images/uno-piggy-bank.png";
import { motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";
import { colors } from "UI/colors";

import { useLocalStorage } from "Utilities/Hooks/useLocalStorage";

FundItInfoSplash.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default function FundItInfoSplash({ settings }) {
  const [isMinimized, setIsMinimized] = useLocalStorage(
    "fundItInfoSplashMinimized",
    false
  );
  const [minimizeTrigger, setMinimizeTrigger] = useState(0);

  const toggleIsMinimized = () => {
    setIsMinimized(!isMinimized);
    setMinimizeTrigger(minimizeTrigger + 1);
  };

  if (!settings.shouldShowPaymentsInfoSplash) return null;

  return (
    <Wrapper>
      <MinimizeIcon
        onClick={toggleIsMinimized}
        animate={{ rotate: isMinimized ? 180 : 0 }}
      >
        <span className="fas fa-chevron-up" />
      </MinimizeIcon>

      <Content
        key={minimizeTrigger}
        initial={{ opacity: minimizeTrigger ? 0 : 1 }}
        animate={{ opacity: 1 }}
      >
        {isMinimized ? (
          <MinContent>
            <PiggyBankImageSmall />
            <MinText>
              <strong>You&apos;ve got Fund It!</strong> Great news- your church
              is set up to start collecting payments for tithing, donations,
              ministry funding, events, &amp; more!
            </MinText>
            <MinButtonWrapper>
              <FnrButton
                onClick={() => window.open("https://flocknote.com/fund-it/")}
                color={colors.fnYellow}
                size="small"
              >
                Learn More
              </FnrButton>
            </MinButtonWrapper>
          </MinContent>
        ) : (
          <>
            <Title>
              <PiggyBankImage /> Online &amp; Mobile Giving
            </Title>
            <Body>
              Great news! You&apos;re set up to start collecting payments for
              tithing, donations, ministry funding, events, &amp; more!
            </Body>
            <Buttons>
              <FnrButton
                onClick={() => window.open("https://flocknote.com/fund-it/")}
                color="#6bc06f"
                size="large"
              >
                <FAQBtnText>Learn More</FAQBtnText>
              </FnrButton>
              <FnrButton
                onClick={() =>
                  window.open(
                    "https://help.flocknote.com/category/347-ways-to-give"
                  )
                }
                color={colors.fnYellow}
                size="large"
              >
                Show me how!
              </FnrButton>
            </Buttons>
          </>
        )}
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: white;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  background: #005078;
  padding: 20px 30px;
`;

const MinimizeIcon = styled(motion.div)`
  display: inline-block;
  position: absolute;
  top: 10px;
  right: 14px;
  cursor: pointer;
`;

const Content = styled(motion.div)``;

const MinContent = styled.div`
  display: flex;

  @media (max-width: 540px) {
    flex-direction: column;
  }
`;

const MinText = styled.div`
  flex: 1;
  font-size: 15px;
`;

const MinButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 5px;
  margin-left: 10px;

  @media (max-width: 540px) {
    justify-content: center;
    margin-top: 10px;
    margin-left: 0;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-style: italic;
  font-size: 28px;
`;

const Body = styled.div`
  margin-top: 18px;
  font-size: 16px;
  font-weight: 400;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  gap: 12px;

  @media (max-width: 474px) {
    flex-direction: column;
  }
`;

const PiggyBankImage = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  background-image: url(${unoPiggyBank});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  width: 52px;
  min-height: 52px;
  margin-right: 10px;

  @media screen and (min-width: 841px) and (max-width: 930px),
    screen and (min-width: 400px) and (max-width: 590px) {
    display: none;
  }
`;

const PiggyBankImageSmall = styled(PiggyBankImage)`
  width: 38px;
  min-height: 38px;
  margin-right: 15px;
`;

const FAQBtnText = styled.div`
  color: ${colors.fnDkBlueGray};
`;
